<template>
  <section class="section">
    <title-bar :title-stack="titleStack">
      Profile
      <div class="level-item action" slot="button">
        <router-link to="/" class="button is-primary" slot="right">Dashboard</router-link>
      </div>
    </title-bar>

    <div>
      <tiles>
        <profile-update-form class="tile is-child" />
        <card-component title="Profile" icon="account" class="tile is-child">
          <user-avatar class="image has-max-width is-aligned-center" />
          <hr />
          <b-field label="Name">
            <b-input :value="name" custom-class="is-static" readonly />
          </b-field>

          <b-field label="E-mail">
            <b-input :value="email" custom-class="is-static" readonly />
          </b-field>
          <b-field label="Role">
            <b-input :value="role | roleIden " custom-class="is-static" readonly />
          </b-field>
          <b-field label="Code No.">
            <b-input :value="code_no" custom-class="is-static" readonly />
          </b-field>
          <b-field label="Office Code No.">
            <b-input :value="office_code_no" custom-class="is-static" readonly />
          </b-field>
          <b-field label="Designation">
            <b-input :value="designation" custom-class="is-static" readonly />
          </b-field>
          <b-field label="Contact Number">
            <b-input :value="contact_number" custom-class="is-static" readonly />
          </b-field>

          <b-field label="Last Login">
            <b-input :value="lastLoggedIn | fromNow" custom-class="is-static" readonly />
          </b-field>
        </card-component>
      </tiles>
      <password-update-form />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import CardComponent from '@/components/CardComponent';
import TitleBar from '@/components/TitleBar';
import HeroBar from '@/components/HeroBar';
import ProfileUpdateForm from '@/components/ProfileUpdateForm';
import PasswordUpdateForm from '@/components/PasswordUpdateForm';
import Tiles from '@/components/Tiles';
import UserAvatar from '@/components/UserAvatar';
export default {
  name: 'Profile',
  components: {
    UserAvatar,
    Tiles,
    PasswordUpdateForm,
    ProfileUpdateForm,

    TitleBar,
    CardComponent,
  },
  filters: {
    roleIden: function (value) {
      if(value == 0){
        return 'Super Admin';
      } else if (value == 1){
          return 'Admin'
      } else if (value == 2){
          return 'Data Admin'
      } else if (value == 4){
          return 'Analytics'
      }
      else {
          return 'Data Clerk';
      }
    }
  },
  data() {
    return {
      name: '',
      email: '',
      role: '',
      code_no: '',
      office_code_no: '',
      lastLoggedIn: '',
      designation: '',
      contact_number: '',
    };
  },
  mounted() {
    this.$store.commit('isNavBarVisible', true);
    this.$root.$on('userProfileUpdated', (name, email, code_no, office_code_no, photoUrl, designation,contact_number) => {
      this.name = name;
      this.email = email;
      this.code_no = code_no;
      this.office_code_no = office_code_no;
      this.designation = designation;
      this.contact_number = contact_number;
    });
  },
  created() {
    this.name = this.$store.state.auth.user.name;
    this.email = this.$store.state.auth.user.email;
    this.role = this.$store.state.auth.user.role;
    this.code_no = this.$store.state.auth.user.code_no;
    this.office_code_no = this.$store.state.auth.user.office_code_no;
    this.lastLoggedIn = this.$store.state.auth.user.lastLoggedIn;
    this.designation = this.$store.state.auth.user.designation;
    this.contact_number = this.$store.state.auth.user.contact_number;
  },
  computed: {
    titleStack() {
      return ['Admin', 'Profile'];
    },
    // name() {
    //     return this.$store.state.auth.user.name
    // },
    // email() {
    //     return this.$store.state.auth.user.email
    // }
  },
};
</script>


<style  scoped>
.is-title-bar {
  margin-bottom: 1rem;
}

@media screen and (max-width: 768px) {
  .level-item:not(:last-child) {
    margin-bottom: 0;
    margin: 10px;
  }
}
</style>